<template>
  <v-container>
    <div class="box mt-10 mb-10">
      <h2>Thông báo số 1 <a target="_blank" href="https://l.facebook.com/l.php?u=https%3A%2F%2Fdrive.google.com%2Ffile%2Fd%2F1YJDMV5zK3-rxgCmNwIDxa9ZQqe1BUF4T%2Fview%3Fusp%3Dsharing%26fbclid%3DIwAR21PicuMKVHjUstblB4-iMECc_-5k7UELLWDD4o3DaUDQ99WYTN4yLaY-g&h=AT2bvrtYMrlZ0zrVeqJPBQsxp_vnk9nrrh1SJe2OSKg9vDmlWJUkW_4K2uDwui-NuKAmLxetWNpVngVofRtPcRqsPTe8a0eXPEWjm8E-XjCwyb5t3S9YqiUnCpza7g"><i class="fas fa-file-pdf"></i></a></h2>
      <h2 class="mb-2">Tài liệu tham khảo</h2>
      <ul>
        <li class="mb-2 ml-1">
          Khóa học về tính toán lượng tử của IBM:
          <a href="https://qiskit.org/learn/intro-qc-qh/ ">https://qiskit.org/learn/intro-qc-qh/ </a>
        </li>
        <li>
          Isaac Chuang, Michael Nielsen, <i>Quantum Computation and Quantum
          Information</i>, Cambridge University Press 2000, ISBN: 9781107002173.
        </li>
        <li>
          Wolfgang Scherer, <i>Mathematics of Quantum Computing</i>, Springer 2019,
          ISBN 978-3-030-12358-1.
        </li>
      </ul>
    </div>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
.box {
  background: white;
  padding: 2rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  border-radius: 4px;
    @media (max-width: 460px) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 10px;
    padding-left:10px ;
    padding-right:10px ;
  }
}
</style>